import { Modal } from 'antd';
import { PropTypes } from 'prop-types';
import React from 'react';
import 'moment/locale/zh-cn';
import { handleMouseDown, initMoveModalLeft } from '../utils/DragUtil';
/**
 *  弹框组件简单版
 */
class FhSimpleModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moveId: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      if (this.props.visible) {
        if (this.props.moveClassName) {
          this.setState({
            moveId: this.props.moveClassName
          });
        } else {
          this.setState({
            moveId: 'moveIdName' + Date.now()
          });
        }
        if (this.props.width) {
          initMoveModalLeft('.' + this.state.moveId + 'moveIdName', this.props.width);
        } else {
          initMoveModalLeft('.' + this.state.moveId + 'moveIdName', 700);
        }
      }
    }
  }

  handleMouseDownFun(e, value) {
    handleMouseDown(e, '.' + value + 'moveIdName');
  }

  render() {
    // antd升版注意:  小于 4.23.0 仍使用 visible, 它仍然会向下兼容，从 v5.0 起visible将从Api中移除该属性替换为open属性
    const { visible, modalTitle, closable, onCancel, onCreate, okText, footer, width, style, className, maskClosable, locale, titleAction, destroyOnClose, okButtonProps, cancelText, confirmLoading } = this.props;
    return (
      <Modal
        visible={visible}
        title={
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }} className='moveModalTitle' onMouseDown={(e) => { e.stopPropagation(); this.handleMouseDownFun(e, this.state.moveId); }}>
              {modalTitle}
            </div>
            {titleAction && <div className='titleAction' style={{ display: 'inline-flex', paddingRight: '34px' }}>
              {titleAction}
            </div>}
          </div>
        }
        closable={closable || closable === undefined}
        locale={{ ...locale }}
        okText={okText || '确定'}
        cancelText={cancelText || '取消'}
        onCancel={onCancel}
        onOk={onCreate}
        width = {width || 700}
        className={className ? className + ' moveCss ' + this.state.moveId + 'moveIdName' : 'addModal moveCss ' + this.state.moveId + 'moveIdName'}
        footer = {footer}
        style={style}
        maskClosable={maskClosable}
        destroyOnClose={destroyOnClose || false}
        okButtonProps={okButtonProps}
      >
        {this.props.children}
      </Modal>
    );
  }
}
export default FhSimpleModal;

// 属性值类型
FhSimpleModal.propTypes = {
  visible: PropTypes.bool, // 弹框是否展示
  onCancel: PropTypes.func, // 取消按钮
  onCreate: PropTypes.func, // 保存按钮方法
  modalTitle: PropTypes.string,
  okText: PropTypes.string, // 确认按钮文本
  cancelText: PropTypes.string, // 取消按钮文本
  className: PropTypes.string, // 弹框样式
  // 弹框内容
  children: PropTypes.object.isRequired,
  footer: PropTypes.any,
  titleAction: PropTypes.any,
  width: PropTypes.number,
  style: PropTypes.object,
  locale: PropTypes.object,
  moveClassName: PropTypes.string, // 弹框移动的唯一class
  maskClosable: PropTypes.bool, // 点击蒙层是否允许关闭
  closable: PropTypes.bool, // 右上角是否显示关闭
  destroyOnClose: PropTypes.bool, // 关闭时销毁 Modal 里的子元素
  okButtonProps: PropTypes.object // ok 按钮 props
};
